const setupScrollEvent = (event) => {
    const scrollLocation = event.target.value;
    
    if (!scrollLocation) {
        return;
    }

    const anchor = document.querySelector(scrollLocation);
    const header = document.querySelector(".site-navigation");

    if (!anchor || !header) {
        return;
    }

    let fixedHeaderBreakPoint = 950;

    // allow child themes to override the fixed header breakpoint
    if(window.universityPressThemeSettings.fixed_header_breakpoint !== 'undefined'){
        fixedHeaderBreakPoint = window.universityPressThemeSettings.fixed_header_breakpoint;
    }

    let anchorOffset = header.offsetHeight;

    if(window.innerWidth < fixedHeaderBreakPoint) {
        anchorOffset = 0;
    }

    const anchorPosition = anchor.getBoundingClientRect().top;
    const offsetPosition = anchorPosition + window.pageYOffset - anchorOffset;

    window.scrollTo({
        top: offsetPosition,
        behavior: "smooth"
   });

};
        

document.addEventListener("DOMContentLoaded", () => {
    const jumpToSelect = document.querySelector("#jump-to");

    if (!jumpToSelect) {
        return;
    }

    jumpToSelect.addEventListener("change", (event) =>
        setupScrollEvent(event)
    );
});
